module.exports = "/assets/QA_V4-6facd719ec1dbf2124ae089e5c4ff8ef.jpg";